$(function () {
  // 在这里编写需要在文档加载完成后执行的代码
  if (!customElements.get('input-number')) {
    customElements.define(
      'input-number',
      class ProductForm extends HTMLElement {
        blurStatus = false;
        constructor() {
          super();
          this.initialized = false;
        }

        connectedCallback() {
          if (!this.initialized) {
            this.init();
            this.initialized = true;
          }
        }

        init() {
          const _this = this;
          const $input = $(this.querySelector('input'));

          // 防止浏览器自动填充缓存的值，强制重置为1
          $input.attr('autocomplete', 'off');
          $input.val(1);

          // 输出当前的值

          // 先移除可能存在的事件绑定
          $input.off('input');

          $input.on('input', function () {
            const max = $input.attr('max');
            // 移除非数字字符
            let value = $(this).val().replace(/[^\d]/g, '');
            // 获取input最大值
            if (value > +max) {
              $input.val(max);
            } else {
              $input.val(value);
            }
          });

          // 检查是否在 cart-select-menu 中
          const isInCartSelectMenu = this.closest('cart-select-menu') !== null;

          $input.on('blur', function () {
            if ($input.val() <= 0) {
              $input.val(1);
              // 只在不是 cart-select-menu 时触发事件
              if (!isInCartSelectMenu) {
                const event = new CustomEvent('quantityChange', { detail: 1 });
                window.dispatchEvent(event);
              }
            }
          });

          const $input_number_minus = $(this.querySelector('.input-number_minus'));
          const $input_number_plus = $(this.querySelector('.input-number_plus'));

          // 移除可能存在的事件绑定
          $input_number_minus.off('click');
          $input_number_plus.off('click');

          $input_number_minus.on('click', function () {
            if ($input.val() > 1) {
              $input.val(+$input.val() - 1);
              // 只在不是 cart-select-menu 时触发事件
              if (!isInCartSelectMenu) {
                const event = new CustomEvent('quantityChange', { detail: $input.val() });
                window.dispatchEvent(event);
              }
            }
          });

          $input_number_plus.on('click', function () {
            const max = $input.attr('max');
            if ($input.val() < +max) {
              if (_this.blurStatus) {
                _this.blurStatus = false;
                return;
              }
              $input.val(+$input.val() + 1);
              // 只在不是 cart-select-menu 时触发事件
              if (!isInCartSelectMenu) {
                const event = new CustomEvent('quantityChange', { detail: $input.val() });
                window.dispatchEvent(event);
              }
            } else {
              // 获取data-message
              const message = $input.attr('data-message');
              window.litime.showToast('error', message);
            }
          });
        }
      }
    );
  }
});
